import { useState } from 'react';
import { Button } from '@savvy-kit/components/button';
import { Spinner } from '@savvy-kit/components/spinner';
import Banner from '@savvy-kit/patterns/banner';

import { useHouseholdArchive } from '../clients/hooks/use-household-archive';

type Props = {
  readonly householdId: string;
  readonly householdName: string;
  readonly onHouseholdStageChanged: () => void;
};

export function ArchivedHouseholdBanner({ householdId, householdName, onHouseholdStageChanged }: Props) {
  const { handleUnarchive: doUnarchive } = useHouseholdArchive({
    onArchive: onHouseholdStageChanged,
    onUnarchive: onHouseholdStageChanged,
  });

  const [restoring, setRestoring] = useState(false);

  const handleUnarchive = async () => {
    setRestoring(true);
    await doUnarchive(householdId, householdName);
    setRestoring(false);
  };

  return (
    <Banner
      actionButton={
        <Button
          className="bg-white dark:bg-card w-17.5"
          disabled={restoring}
          onClick={handleUnarchive}
          size="sm"
          variant="secondary"
        >
          {restoring ? <Spinner /> : 'Restore'}
        </Button>
      }
      className="bg-muted border-border-light"
      description="This client has been archived. In order to edit, the household will need to be restored"
      variant="info"
    />
  );
}
